import moment from "moment-timezone";
import { MESSAGE_TYPES } from "../../Models/Enum";
import { MESSAGE_TYPES as SOCKET_MESSAGE_TYPES } from "./Enum";
import { DEVICE_SIZE } from "./BreakPoints";
import uniqid from "uniqid";

export const handleURLClick = (url: any) => {
  window.open(url, "_blank");
};

export const hexToRgb = (hex: string) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)},${parseInt(
        result[3],
        16
      )}`
    : null;
};

export const extractPreviousBtnConversationId = (
  originalNodeResponses: any[],
  item: any
) => {
  const data_filter: any = originalNodeResponses.filter(function (
    element: any,
    index: number
  ) {
    return element?.response?.some(function (subElement: any, index4: number) {
      return (
        subElement?.type === MESSAGE_TYPES.FLOW && subElement.id === item?.id
      );
    });
  });

  // console.log("foundConversationId", data_filter);
  let foundConversationId = data_filter[0]?.conversation_id;

  return foundConversationId;
};

export const stringToRegex = (str: any) => {
  // Main regex
  const main = str?.match(/\/(.+)\/.*/)[1];

  // Regex options
  const options = str?.match(/\/.+\/(.*)/)[1];

  // Compiled regex
  return new RegExp(main, options);
};

export const isEmptyObject = (obj: object) => {
  return Object.keys(obj).length === 0;
};

export const getText = (response: any) => {
  let text = "";
  if (response && response !== null && response.length > 0) {
    const match = response.filter(
      (item: any) => item.type === "text" || item.type === "carousel"
    );
    if (match.length > 0) {
      if (match?.[0]?.value) {
        if (Array.isArray(match?.[0]?.value) && match?.[0]?.value?.length > 0) {
          text = match?.[0]?.value?.[0].text;
        } else {
          text = match?.[0]?.value;
        }
      } else if (match?.[0]?.text) {
        text = match?.[0]?.text;
      } else {
        text = "";
      }
    }
  }
  return text;
};

export const getChatbotWidth = (size?: number) => {
  if (size && size < DEVICE_SIZE.mobileL) {
    return size;
  } else {
    return 376;
  }
};

export const getChatbotHeight = (
  deviceWidth?: number,
  deviceHeight?: number
) => {
  if (deviceWidth && deviceHeight && deviceWidth < DEVICE_SIZE.mobileL) {
    let temp = deviceHeight - 30;
    return temp;
  } else {
    return deviceHeight || 0;
  }
};

export const titlize = (str: string) => {
  return str
    ? str
        ?.toLowerCase()
        ?.split(" ")
        ?.map((word) => {
          return word.replace(word[0], word[0].toUpperCase());
        })
        ?.join(" ")
    : "";
};

export const secondsToHms = (value: string) => {
  const sec = parseInt(value, 10);
  let hours: string | number = Math.floor(sec / 3600);
  let minutes: string | number = Math.floor((sec - hours * 3600) / 60);
  let seconds: string | number = sec - hours * 3600 - minutes * 60;
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  if (hours === 0) {
    return +minutes + ":" + seconds; // Return in MM:SS format
  } else {
    return hours + ":" + minutes + ":" + seconds; // Return in HH:MM:SS format
  }
};

export const wrapWithPTags = (text: string): string => {
  return `<p>${text}</p>`;
};

export const checkQuickQuickActionFaqButtonEnable = (data: any[]) => {
  let enabled = false;
  if (data?.length > 0) {
    data?.forEach((item: any, index: number) => {
      if (item?.type === "user-query" && item?.enabled === true) {
        enabled = true;
      }
    });
  }

  return enabled;
};

export const renderTime = (time: string) => {
  let daysDiff = moment().diff(moment(time), "days");
  if (daysDiff < 2) {
    return moment(time).fromNow();
  } else if (daysDiff < 365) {
    return moment(time).format("MMM DD, HH:mm A");
  } else {
    return moment(time).format("MMM DD YYYY, HH:mm A");
  }
};

export const getMessageTime = (datetime: string): string => {
  let messageTime = moment.utc(datetime, "ddd, DD MMM YYYY HH:mm:ss ZZ");

  if (!messageTime.isValid()) {
    messageTime = moment();
  }

  const currentTime = moment();

  const isToday = messageTime.isSame(currentTime, "day");
  const timeFormat = isToday ? "h:mm A" : "MMM D, h:mm A";

  return messageTime.local().format(timeFormat);
};

export const getCurrentUTCTime = (): string => {
  const currentUTCTime = moment.utc().format("ddd, DD MMM YYYY HH:mm:ss");
  return currentUTCTime + " GMT";
};

export const getHeaderStatusText = (
  isSocketConnected: boolean,
  typingStatus?: string | null,
  showIdleState: boolean = false
): string => {
  if (!isSocketConnected) return showIdleState ? "Offline \u00b7 reconnecting" : "";
  if (typingStatus) return typingStatus;
  return showIdleState ? "Online" : "";
};

export const isWithinBusinessHour = (data: any) => {
  // console.log("business hour data", data);

  if (!data || !data?.activeOperatingHours) {
    console.warn("no business time config found");
    return {
      isChatWithInTime: true,
      timelogs: { reason: "no business time config found" },
    };
  }

  const timezoneCurrentDay = moment.utc().format("dddd").toLowerCase();

  if (!data?.[timezoneCurrentDay]?.enabled) {
    console.warn("business is closed for the given day");
    return {
      isChatWithInTime: false,
      timelogs: { reason: "business is closed for the given day" },
    };
  }

  //* business timezone
  const timezone = data?.timezone?.id || "Asia/Kolkata";
  //* Get the UTC offset for the specified timezone
  const utcOffset = moment.tz(timezone).utcOffset();

  let startHours = data?.[timezoneCurrentDay]?.start?.slice(0, 2) || "10";
  let startMinutes = data?.[timezoneCurrentDay]?.start?.slice(3, 5) || "30";
  // if (startHours == '00') {
  //   startHours = startHours.replace(/^.{2}/g, '24')
  // }

  let endHours = data[timezoneCurrentDay]?.end?.slice(0, 2) || "10";
  let endMinutes = data[timezoneCurrentDay]?.end?.slice(3, 5) || "30";
  // if (endHours == '00') {
  //   endHours = endHours.replace(/^.{2}/g, '24')
  // }

  // Set the currentUtcMoment to the desired day, hours, and minutes
  const utcStartTime = moment
    .utc()
    .day(timezoneCurrentDay)
    .hour(startHours)
    .minute(startMinutes)
    .second(0)
    .millisecond(0);

  const utcEndTime = moment
    .utc()
    .day(timezoneCurrentDay)
    .hour(endHours)
    .minute(endMinutes)
    .second(0)
    .millisecond(0);

  // Subtract the UTC offset from utcStartTime and utcEndTime
  const adjustedUtcStartTime = utcStartTime
    .clone()
    .subtract(utcOffset, "minutes");
  const adjustedUtcEndTime = utcEndTime.clone().subtract(utcOffset, "minutes");

  const isBetween =
    moment.utc().isBetween(adjustedUtcStartTime, adjustedUtcEndTime) || false;

  const timelogs = {
    configTimezone: timezone,
    configUTCOffset: utcOffset,
    configStart: startHours + ":" + startMinutes,
    configEnd: endHours + ":" + endMinutes,
    browserCurrentDay: timezoneCurrentDay,
    browserUTC: moment.utc().format(),
    startUTC: adjustedUtcStartTime.format(),
    endUTC: adjustedUtcEndTime.format(),
    isChatWithinBusinessHour: isBetween,
    reason: isBetween ? null : "Business is closed for the given day",
  };

  console.warn(timelogs);

  return { isChatWithInTime: isBetween, timelogs: timelogs };
};

export const renderTextWithLinks = (htmlString: string) => {
  // Regular expression to match URLs
  const regex = /(https?:\/\/[^<>\s]+)/g;
  const parts = htmlString?.split(regex);

  if (!parts) return htmlString;

  return parts
    ?.map((part: any, index: number) => {
      if (part?.match(regex)) {
        return `<a href="${part}" target="_blank" rel="noopener noreferrer">${part}</a>`;
      }
      return part;
    })
    .join("");
};

export const getDefaultAvatar = (text?: string, index: number = 0) => {
  let a = text || "U";
  let result = a?.trim().charAt(index).toUpperCase() || "U";
  if (result === "+" || typeof result === "number") {
    result = "W";
  }
  return result;
};

export async function sleep(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export async function generateOutsideHoursMessage(
  message: string,
  sessionId: string,
  socket: any
) {
  return {
    type: "text",
    value: message,
    session_id: sessionId,
    isUser: false,
    socket_id: socket?.id,
    time: getCurrentUTCTime(),
    message_id: uniqid(),
  };
}

export async function generateConnectSocketToAgent(
  message: string,
  sessionId: string,
  socket: any,
  timelogs: any
) {
  return {
    type: "text",
    value: message,
    session_id: sessionId,
    isUser: true,
    socket_id: socket?.id,
    time: getCurrentUTCTime(),
    message_id: uniqid(),
    timelogs: timelogs,
  };
}

export const getWidgetDevice = (
  config: any,
  wid: number
): "mobile" | "desktop" => {
  const device = wid < 768 ? "mobile" : "desktop";
  return device ?? "mobile";
};

export const getWidgetPositionConfig = ({ config, IframeDimensions }: any) => {
  const device = IframeDimensions?.actualWidth < 768 ? "mobile" : "desktop";
  const position =
      (device === "mobile"
        ? config?.mobile_display_position
        : config?.desktop_display_position) ?? "Right";
  const bottomMargin =
    ((device === "mobile"
      ? config?.mobile_bottom_margin
      : config?.desktop_bottom_margin) ?? 10) + "px";
  const sideMargin =
    ((device === "mobile"
      ? config?.mobile_side_margin
      : config?.desktop_side_margin) ?? 10) + "px";
  return { device, position, bottomMargin, sideMargin };
};

export const getDayThroughDate = (date: string) => {
  const days = ['SAT', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  var d = new Date(date);
  return days[d.getDay()];
}

export const sendDataToParent = (eventName:string,data:any) => {
  window.parent?.postMessage({ type: eventName, data: data }, "*");
};

/**
 * Convert file extension to MIME type
 * @param ext - File extension (e.g., 'pdf', 'jpg')
 * @returns MIME type string
 */
export const extensionToMimeType = (ext: string): string => {
  const mimeMap: { [key: string]: string } = {
    // Image formats
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png',
    'svg': 'image/svg+xml',
    'webp': 'image/webp',
    'gif': 'image/gif',

    // Video formats
    'mp4': 'video/mp4',
    'webm': 'video/webm',

    // Audio formats
    'mp3': 'audio/mpeg',
    'wav': 'audio/wav',

    // Document formats
    'pdf': 'application/pdf',
    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'csv': 'text/csv',
    'doc': 'application/msword',
    'xls': 'application/vnd.ms-excel',
    'ppt': 'application/vnd.ms-powerpoint',
    'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'txt': 'text/plain',
  };
  return mimeMap[ext.toLowerCase()] || 'application/octet-stream';
};

/**
 * Convert array of file extensions to MIME types
 * @param extensions - Array of file extensions
 * @returns Array of MIME types
 */
export const convertExtensionsToMimeTypes = (extensions: string[]): string[] => {
  return extensions.map(ext => extensionToMimeType(ext));
};

/**
 * Check if a message is a file upload from user
 * @param message - Message object to check
 * @returns Boolean indicating if message is a file upload
 */
export const isFileUploadMessage = (message: any): boolean => {
  if (!message?.isUser) return false;
  return message?.type === SOCKET_MESSAGE_TYPES.FILE
};


/**
 * Generic function to check if a message is an input type selection from user
 * @param message - Message object to check
 * @param lastNodeResponse - Last node response to verify the input type
 * @param inputType - The input type to check for ("DATE" or "TIME")
 * @returns Boolean indicating if message is a selection of the specified input type
 */
export const isInputTypeSelectionMessage = (
  message: any, 
  lastNodeResponse: any, 
  inputType: "DATE" | "TIME"
): boolean => {
  if (!message?.isUser) return false;
  // Check if the last node response input type matches and the user has submitted a text response
  return message?.type === SOCKET_MESSAGE_TYPES.TEXT && lastNodeResponse?.input_type === inputType;
};

/**
 * Check if a message is a date selection from user
 * @param message - Message object to check
 * @param lastNodeResponse - Last node response to verify it was a date input
 * @returns Boolean indicating if message is a date selection
 */
export const isDateSelectionMessage = (message: any, lastNodeResponse: any): boolean => {
  return isInputTypeSelectionMessage(message, lastNodeResponse, "DATE");
};

/**
 * Check if a message is a time selection from user
 * @param message - Message object to check
 * @param lastNodeResponse - Last node response to verify it was a time input
 * @returns Boolean indicating if message is a time selection
 */
export const isTimeSelectionMessage = (message: any, lastNodeResponse: any): boolean => {
  return isInputTypeSelectionMessage(message, lastNodeResponse, "TIME");
};

export const getTruncatedFileName = (url: string, maxLength: number = 30) => {
  if (!url) return "";

  const urlWithoutParams = url.split('?')[0];
  let fileName = urlWithoutParams.substring(urlWithoutParams.lastIndexOf('/') + 1);

  const underscoreIndex = fileName.indexOf('_');
  if (underscoreIndex !== -1) {
    fileName = fileName.substring(underscoreIndex + 1);
  }

  if (fileName.length <= maxLength) {
    return fileName;
  }

  const lastDotIndex = fileName.lastIndexOf('.');
  const extension = lastDotIndex !== -1 ? fileName.substring(lastDotIndex) : '';
  const nameWithoutExtension = lastDotIndex !== -1 ? fileName.substring(0, lastDotIndex) : fileName;

  const extensionLength = extension.length;
  const availableLength = maxLength - extensionLength - 3; // 3 for "..."

  if (availableLength <= 0) {
    return fileName.substring(0, maxLength - 3) + '...';
  }

  return nameWithoutExtension.substring(0, availableLength) + '...' + extension;
};
